import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-video-dialog',
    templateUrl: 'video-dialog.component.html',
    styleUrls: ['video-dialog.component.scss'],
})
export class VideoDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<VideoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { videoId: string; videoUrl?: string }
    ) {}

    getVideoUrl(): string {
        if (this.data.videoUrl) {
            return this.data.videoUrl;
        }
        return `https://www.youtube.com/embed/${this.data.videoId}?autoplay=1`;
    }
}
